module.exports = __webpack_public_path__ + "img/donante-kadima.db7c5929.png";